import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { UserDto } from '@zopup/zop-types';
import { StorageKey } from '../enums/storage-key';

@Injectable({providedIn: 'root'})
export class StorageService
{
    user$ = new Subject<UserDto>();
    
    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    // eslint-disable-next-line @typescript-eslint/member-ordering
    get user(): UserDto {
        return JSON.parse(localStorage.getItem('user')!) ?? undefined;
    }

    set user(user: UserDto) {
        this.user$.next(user);
        localStorage.setItem('user', JSON.stringify(user));
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    // get roles(): UserRole[] | undefined {
    //     return this.user.tenants?.filter((tenant: any) => tenant.id === this.selectedTenant.id)[0].roles;
    // }

    getItem<T>(key: StorageKey): T {
        return JSON.parse(localStorage.getItem(key)!) as T;
    }

    setItem<T>(key: StorageKey, value: T): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    removeItem(key: StorageKey): void {
        localStorage.removeItem(key);
    }

    clearStorage(): void {
      try {
          localStorage.clear();
          // if (localStorage.getItem('firebaseUser') !== '' && localStorage.getItem('accessToken') !== '') {
          //     this._authenticated = true;
          // } else {
          //     this._authenticated = false;
          // }
      } catch(ex) {
          console.error('Error while constructring error response!');
      }
    }
}
